import { usePurchaseButtonContext } from './Context'
import { purchaseOrderFragment as purchaseOrderFragmentCore } from '@ztechapps/purchase-order.common'
import { HorizontalStack, ShowIf } from '@ztechapps/webui.util'
import { Stack } from 'react-bootstrap'
import type { SelectOption } from '@ztechapps/webui.input'
import type { PurchaseOrder } from '@ztechapps/common.contract'
import { PurchaseOrderStatusEnum } from '@ztechapps/common.contract'
import { BusyButton } from '@ztechapps/webui.button'
import React from 'react'
import { buildGraphqlQuery } from '@ztechapps/common.utils'
import { useMutation } from '@ztechapps/common.hook'
import type { PurchaseOrderSelectProps } from '@ztechapps/webui.contract'
import { useInjectComponent, WebuiIocKey } from '@ztechapps/webui.contract'

export const queries = buildGraphqlQuery('PurchaseOrder', purchaseOrderFragmentCore, ['items'])

export const ExistingPurchaseOrder = () => {
  const PurchaseOrderSelect = useInjectComponent<PurchaseOrderSelectProps>(
    WebuiIocKey.purchaseOrder.purchaseOrderSelect
  )
  const {
    product,
    qtyNeededToBuild,
    actionType,
    purchaseOrder,
    setPurchaseOrder,
    truncatedProductName,
    useErrorResult,
    setPurchaseOrderResult,
    setShowConfirm,
  } = usePurchaseButtonContext()
  const { onError } = useErrorResult

  const [onAdd, , { loading }] = useMutation({ query: queries.createPurchaseOrder_itemsConfig.query })

  const handleAddExisting = async () => {
    try {
      const result = await onAdd({
        filter: { _id: purchaseOrder?._id },
        input: {
          product: {
            _id: product?._id,
            code: product?.code,
          },
          quantity: qtyNeededToBuild,
        },
      })
      setPurchaseOrderResult(result?.data?.createPurchaseOrder_items)
    } catch (e) {
      onError(e)
    } finally {
      //error or not, show the confirm
      setShowConfirm(true)
    }
  }

  return (
    <ShowIf condition={actionType === 'existing'}>
      <Stack gap={2}>
        <HorizontalStack>
          <div className="flex-grow-1">
            <PurchaseOrderSelect
              disabled={loading}
              placeholder="Choose from existing purchase orders to be updated."
              showInfo={true}
              value={purchaseOrder as unknown as SelectOption<PurchaseOrder>}
              filter={{
                status: {
                  $nin: [
                    PurchaseOrderStatusEnum.Cancelled,
                    PurchaseOrderStatusEnum.Received,
                    PurchaseOrderStatusEnum.PartiallyReceived,
                  ],
                },
              }}
              onChange={(e) => setPurchaseOrder(e as unknown as PurchaseOrder)}
              autoFocus
            />
          </div>
        </HorizontalStack>
        <BusyButton
          onClick={handleAddExisting}
          icon="cart-shopping"
          text={`Add "${truncatedProductName}" to existing purchase order`}
          disabled={!purchaseOrder}
          isBusy={loading}
        />
      </Stack>
    </ShowIf>
  )
}
